;(() => {
  const angular = window.angular;

  PermissionsCategoryCtrl.$inject = ['$scope'];

  angular
    .module('app')
    .component('permissionsCategory', {
      template:'<table class="table table-bordered permission-table table-hover" ng-if="ctrl.plainPermissions.length"><thead><tr><th><div ng-click="ctrl.expanded = !ctrl.expanded" class="cursor-pointer"><h4 translate>{{\'entities.permission.\' + ctrl.category + \'.label\' }}</h4><div class="small"><a>{{ctrl.expanded ? \'buttons.hide\' : \'buttons.expand\' | translate}}</a></div></div></th><th class="type-column" title="Create"><span translate class="marginB5">buttons.create</span><toggle-switch ng-model="ctrl.create.enabled" indeterminate="ctrl.create.indeterminate" ng-change="ctrl.toggle(\'create\')"></toggle-switch></th><th class="type-column" title="Update"><span translate class="marginB5">buttons.update</span><toggle-switch ng-model="ctrl.update.enabled" indeterminate="ctrl.update.indeterminate" ng-change="ctrl.toggle(\'update\')"></toggle-switch></th><th class="type-column" title="Remove"><span translate class="marginB5">buttons.delete</span><toggle-switch ng-model="ctrl.delete.enabled" indeterminate="ctrl.delete.indeterminate" ng-change="ctrl.toggle(\'delete\')"></toggle-switch></th><th class="type-column" title="View"><span translate class="marginB5" ng-if="ctrl.view">buttons.view</span><toggle-switch ng-model="ctrl.view.enabled" ng-if="ctrl.view" indeterminate="ctrl.view.indeterminate" ng-change="ctrl.toggle(\'view\')"></toggle-switch></th></tr></thead><tbody ng-show="ctrl.expanded"><tr ng-repeat-start="permission in ctrl.permissions"><td class="paddingL10"><strong translate>{{\'entities.permission.\' + ctrl.category + \'.children.\' + permission.id}}</strong></td><td class="checkbox-cell"><label class="checkbox" ng-if="ctrl.typeOf(permission.value.create) === \'boolean\'"><input type="checkbox" ng-model="permission.value.create" ng-change="ctrl.checkCategoryState(\'create\')"> <i></i></label></td><td class="checkbox-cell"><label class="checkbox" ng-if="ctrl.typeOf(permission.value.update) === \'boolean\'"><input type="checkbox" ng-model="permission.value.update" ng-change="ctrl.checkCategoryState(\'update\')"> <i></i></label></td><td class="checkbox-cell"><label class="checkbox" ng-if="ctrl.typeOf(permission.value.delete) === \'boolean\'"><input type="checkbox" ng-model="permission.value.delete" ng-change="ctrl.checkCategoryState(\'delete\')"> <i></i></label></td><td class="checkbox-cell"><label class="checkbox" ng-if="ctrl.typeOf(permission.value.view) === \'boolean\'"><input type="checkbox" ng-model="permission.value.view" ng-change="ctrl.checkCategoryState(\'view\')"> <i></i></label></td></tr><tr ng-repeat-end ng-repeat="children in permission.children"><td class="paddingLR20"><span translate>{{\'entities.permission.\' + ctrl.category + \'.children.\' + children.id}}</span></td><td class="checkbox-cell"><label class="checkbox" ng-if="ctrl.typeOf(children.value.create) === \'boolean\'"><input type="checkbox" ng-model="children.value.create" ng-change="ctrl.checkCategoryState(\'create\')"> <i></i></label></td><td class="checkbox-cell"><label class="checkbox" ng-if="ctrl.typeOf(children.value.update) === \'boolean\'"><input type="checkbox" ng-model="children.value.update" ng-change="ctrl.checkCategoryState(\'update\')"> <i></i></label></td><td class="checkbox-cell"><label class="checkbox" ng-if="ctrl.typeOf(children.value.delete) === \'boolean\'"><input type="checkbox" ng-model="children.value.delete" ng-change="ctrl.checkCategoryState(\'delete\')"> <i></i></label></td><td class="checkbox-cell"></td></tr></tbody></table>',
      controller: PermissionsCategoryCtrl,
      controllerAs: 'ctrl',
      bindings: {
        category: '<',
        permissions: '<',
        onChange: '&',
      },
    });

  function PermissionsCategoryCtrl($scope) {
    const vm = this;

    vm.$onInit = function () {
      vm.expanded = false;
      vm.typeOf = typeOf;
      vm.toggle = toggle;

      vm.create = {enabled: false, indeterminate: false};
      vm.update = {enabled: false, indeterminate: false};
      vm.delete = {enabled: false, indeterminate: false};

      vm.checkCategoryState = checkCategoryState;

      init();
      $scope.$watch('ctrl.permissions', () => {
        init();
      }, true);
    };

    function init() {
      vm.plainPermissions = getPlainArray();
      const hasView = vm.plainPermissions.findIndex(current => current.module) !== -1;
      const actions = hasView ? ['view', 'create', 'update', 'delete'] : ['create', 'update', 'delete'];
      vm.view = hasView ? {enabled: false, indeterminate: false} : null;

      actions.forEach(current => {
        checkCategoryState(current, true);
      });
    }

    function typeOf(variable) {
      return typeof variable;
    }

    function checkCategoryState(type, silence) {
      vm[type].count = 0;
      let total = 0;
      vm.plainPermissions.forEach(permission => {
        if (!permission.value) {
          return;
        }
        if (permission.value[type] === true) {
          vm[type].count++;
        }

        if (typeof permission.value[type] === 'boolean') {
          total++;
        }
      });
      vm[type].enabled = vm[type].count === total;
      vm[type].indeterminate = vm[type].count !== 0 && vm[type].count !== total;

      if (vm.onChange && !silence) {
        vm.onChange();
      }
    }

    function getPlainArray() {
      const plainArray = [];
      vm.permissions.forEach(permission => {
        plainArray.push(permission);

        if (permission.children) {
          Array.prototype.push.apply(plainArray, permission.children);
        }
      });

      return plainArray;
    }

    function toggle(type) {
      vm.plainPermissions.forEach(current => {
        if (current.value && typeof current.value[type] === 'boolean') {
          current.value[type] = vm[type].enabled;
        }
      });
      if (vm.onChange) {
        vm.onChange();
      }
    }
  }

})();
